import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { WorkflowHistoryPageComponent } from './modules/shared/workflow-history/workflow-history.component';
import { LandingPageComponent } from './modules/purchase-modes/purchase-modes.component';
import { ApprovingOfficerPageComponent } from './modules/approving-officer-page/approving-officer-page.component';
import { MyDocumentsComponent } from './modules/my-documents/my-documents.component';
import { WorklistPageComponent } from './modules/my-worklist/my-worklist.component';
import { AddItemPageComponent } from './modules/mypurchase-form';
import { MyPurchaseFormComponent } from './modules/mypurchase-form/mypurchase-form.component';
import { OutputHistoryComponent } from './modules/shared/output-history/output-history.component';
import { ResultsPageComponent } from './modules/my-documents/results-page/results-page.component';
import { AuditLogPageComponent } from './modules/shared/audit-log/audit-log.component';
import { TagItemVendorComponent } from './modules/mypurchase-form/tagging/tag-item-vendor/tag-item-vendor.component';
import { canActivateDraftDocRoute } from './core/services/permissions/permission.service';
import { UnauthorizedPageComponent } from './modules/unauthorized/unauthorized-page.component';
import { ReportsPageComponent } from './modules/reports-page/reports-page.component';
import { NotfoundPageComponent } from './modules/shared/notfound/notfound-page/notfound-page.component';
import { TaggingAddComponent } from './modules/mypurchase-form/rfs/tagging-add/tagging-add.component';

import { RfqOutputComponent } from './modules/mypurchase-form/rfq-output/rfq-output.component';
import { PeWorklistComponent } from './modules/pe-worklist/pe-worklist.component';
import { RfqSummaryComponent } from './modules/rfq-summary/rfq-summary.component'; 
import { RfqReportPageComponent } from './modules/rfq-report-page/rfq-report-page.component';
import { ConnectionLostComponent } from './modules/connection-lost/connection-lost.component';
import { SomethingWentWrongComponent } from './modules/something-went-wrong/something-went-wrong.component';

export const routes: Routes = [
  {
    path: 'home',
    component: LandingPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'land',
    component: MyDocumentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    component: ReportsPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'worklist',
    component: WorklistPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase/:purchaseType/:id',
    component: MyPurchaseFormComponent,
    canActivate: [AuthGuard, canActivateDraftDocRoute],
  },
  {
    path: 'purchase/:purchaseType/:id/history',
    component: WorkflowHistoryPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase/:purchaseType/:id/audit-log',
    component: AuditLogPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: MyDocumentsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase/:purchaseType/:id/edit/:itemNo',
    component: AddItemPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase/:purchaseType/:id/output',
    component: OutputHistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase/:purchaseType/:id/rfq-output',
    component: RfqOutputComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'purchase/:purchaseType/:id/add',
    component: AddItemPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'purchase/:purchaseType/:id/tag-item-vendor',
    component: TaggingAddComponent,
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'purchase/:purchaseType/:id/tag-item-vendor',
  //   component: TagItemVendorComponent,
  //   canActivate: [AuthGuard]
  // },
  // {
  //   path: 'purchase/:purchaseType/:id/tag-item-vendor/:itemNo',
  //   component: TagItemVendorComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'worklist/:id/:dagId',
    component: ApprovingOfficerPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'worklist/:id/:dagId/history',
    component: WorkflowHistoryPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'worklist/:id/:dagId/audit-log',
    component: AuditLogPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'redirect',
    redirectTo: '/home'
  },
  {
    path: 'search',
    component: ResultsPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'notfound',
    component: NotfoundPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'peworklist',
    component: PeWorklistComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'rfqSummary',
    component: RfqSummaryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'rfqSummary/:id',
    component: RfqSummaryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'rfqSummary/:id/audit-log',
    component: AuditLogPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'rfqReports',
    component: RfqReportPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'connectionLost',
    component: ConnectionLostComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'wentWrong',
    component: SomethingWentWrongComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }